import React from "react";
import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <div className="top-header sticky-top">
      <nav className="navbar navbar-light bg-white navbar-expand-lg shadow-sm" data-bs-theme="light">
        <div className="container-xl">
          {/* Logo */}
          <Link className="navbar-brand logo-wrapper text-center p-0" to={"/"}>
            <img src={require("../assets/images/logo.png")} alt="Logo" className="img-fluid" />
          </Link>

          {/* Desktop Navigation */}
          <div className="d-none d-md-flex align-items-center">
            <ul className="navbar-nav menu-link-nav align-items-center flex-row gap-3">
              <li className="nav-item">
                <Link to={'/'} className="nav-link">Home</Link>
              </li>
              <li className="nav-item">
                <Link to={'/about'} className="nav-link">About</Link>
              </li>
              <li className="nav-item">
                <Link to={'/communities'} className="nav-link">Communities</Link>
              </li>
              <li className="nav-item">
                <Link to={'/features'} className="nav-link">Features</Link>
              </li>
              <li className="nav-item">
                <Link to={'/marketplace'} className="nav-link">Marketplace</Link>
              </li>
              <li className="nav-item">
                <Link to={'/pricing'} className="nav-link">Pricing</Link>
              </li>
              <li className="nav-item">
                <Link to={'/contact'} className="nav-link">Contact</Link>
              </li>
            </ul>
            
            {/* Right side buttons */}
            <div className="d-flex align-items-center gap-3 ms-3">
              <Link to={'/login'} className="btn btn-outline-theme1 px-3 py-1 rounded-pill fw-medium">
                Login
              </Link>
              {/* <Link to={'/signup'} className="btn btn-theme1 px-3 py-1 rounded-pill fw-medium">
                Sign Up
              </Link> */}
            </div>
          </div>

          {/* Mobile toggle */}
          <button className="navbar-toggler border-0 shadow-none d-md-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTopHeader" aria-controls="offcanvasTopHeader">
            <i className="bi bi-list fs-3 text-dark"></i>
          </button>

          {/* Mobile Offcanvas menu */}
          <div className="offcanvas offcanvas-end border-0 d-md-none" tabIndex="-1" id="offcanvasTopHeader" aria-labelledby="offcanvasTopHeaderLabel">
            <div className="offcanvas-header bg-white border-bottom">
              <h5 className="offcanvas-title text-dark fw-bold">Menu</h5>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div className="offcanvas-body bg-white">
              <ul className="navbar-nav menu-link-nav flex-column gap-3">
                <li className="nav-item">
                  <Link to={'/'} className="nav-link">Home</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/about'} className="nav-link">About</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/communities'} className="nav-link">Communities</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/features'} className="nav-link">Features</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/pricing'} className="nav-link">Pricing</Link>
                </li>
                <li className="nav-item">
                  <Link to={'/contact'} className="nav-link">Contact</Link>
                </li>
              </ul>
              <div className="mt-4 d-flex flex-column gap-3">
                <Link to={'/login'} className="btn btn-outline-theme1 px-4 py-2 rounded-pill fw-medium">
                  Login
                </Link>
                {/* <Link to={'/signup'} className="btn btn-theme1 px-4 py-2 rounded-pill fw-medium">
                  Sign Up
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};
